export enum Permission {
  'Ventas' = 'Ventas',
  'Ventas.NuevaSolicitud' = 'Ventas.NuevaSolicitud',
  'Ventas.ContinuarSolicitud' = 'Ventas.ContinuarSolicitud',
  'Ventas.VerCatalogo' = 'Ventas.VerCatalogo',
  'Ventas.PrecalificacionCredito' = 'Ventas.PrecalificacionCredito',
  'Gestion.Comercial' = 'Gestion.Comercial',
  'Gestion.Comercial.Dashboard' = 'Gestion.Comercial.Dashboard',
  'Gestion.Comercial.Dashboard.TotalVentasTiendas' = 'Gestion.Comercial.Dashboard.TotalVentasTiendas',
  'Gestion.Comercial.MisTiendas' = 'Gestion.Comercial.MisTiendas',
  'Gestion.Comercial.ComisionesPorMarca' = 'Gestion.Comercial.ComisionesPorMarca',
  'Gestion.Comercial.Pagos' = 'Gestion.Comercial.Pagos',
  'Gestion.Comercial.Reportes' = 'Gestion.Comercial.Reportes',
  'Gestion.Comercial.Reportes.Ventas' = 'Gestion.Comercial.Reportes.Ventas',
  'Gestion.Comercial.Reportes.Ventas.SeleccionGerenteTienda' = 'Gestion.Comercial.Reportes.Ventas.SeleccionGerenteTienda',
  'Gestion.Comercial.Reportes.SeleccionTienda' = 'Gestion.Comercial.Reportes.SeleccionTienda',
  'Recaudos' = 'Recaudos',
  'Recaudos.RecargasCW' = 'Recaudos.RecargasCW',
  'Recaudos.LukiCashIn' = 'Recaudos.LukiCashIn',
  'Recaudos.LukiCashOut' = 'Recaudos.LukiCashOut',
  'Gestion' = 'Gestion',
  'Gestion.Precios' = 'Gestion.Precios',
  'Gestion.EstadoCuenta' = 'Gestion.EstadoCuenta',
  'SolicitudPago' = 'SolicitudPago',
  'SolicitudPago.Buscar' = 'SolicitudPago.Buscar',
  'SolicitudPago.GenerarPagoTerceros' = 'SolicitudPago.GenerarPagoTerceros',
  'Consultas' = 'Consultas',
  'Consultas.PinDesbloqueo' = 'Consultas.PinDesbloqueo',
  'Reportes' = 'Reportes',
  'Reportes.CierreVentas' = 'Reportes.CierreVentas',
  'Reportes.Ventas' = 'Reportes.Ventas',
  'Reportes.PagosTienda' = 'Reportes.PagosTienda',
  'Reportes.Recaudos' = 'Reportes.Recaudos',
  'Reportes.VentasProductosAdicionales' = 'Reportes.VentasProductosAdicionales',
  'Tienda.Configuracion.Geolocalizacion' = 'Tienda.Configuracion.Geolocalizacion'
}
